module.exports = __webpack_public_path__ + "img/json-file.1eee5b07.svg";